module.exports = __webpack_public_path__ + "static/img/francesca_queen.286a059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/francesca_queen.png
// module id = Q7JK
// module chunks = 0